module.exports = __webpack_public_path__ + "img/distance_liquid.d889ae2b.png";